import { Pagination, ProtoListRequest } from '@lsq-frontend/angular-shared/api-service';
import { PayableStatus } from '../../../model/models';

export class ListInvoicePayLaterEligibleForBuyerRequest extends ProtoListRequest {
    public refBuyerKey: string;
    public payableNameSearch: string;
    public pagination: Pagination;
    public sellerKeys: string[];
    public dateRange: DateRange;
    public dueDateRange: DateRange;
    public buyerInvoiceStatus?: PayableStatus[];
    constructor(obj?: {
        refBuyerKey?: string;
        payableNameSearch?: string;
        pagination?: Pagination;
        sellerKeys?: string[];
        buyerInvoiceStatus?: PayableStatus[];
        dateRange?: {
            startDate: string;
            endDate: string;
        };
        dueDateRange?: {
            startDate: string;
            endDate: string;
        };
    }) {
        super();
        if (obj != null) {
            this.refBuyerKey =
                typeof obj.refBuyerKey === 'undefined' ? this.refBuyerKey : obj.refBuyerKey;
            this.payableNameSearch =
                typeof obj.payableNameSearch === 'undefined'
                    ? this.payableNameSearch
                    : obj.payableNameSearch;
            this.pagination =
                typeof obj.pagination === 'undefined' ? this.pagination : obj.pagination;
            this.sellerKeys =
                typeof obj.sellerKeys === 'undefined' ? this.sellerKeys : obj.sellerKeys;
            this.dateRange = typeof obj.dateRange === 'undefined' ? this.dateRange : obj.dateRange;
            this.dueDateRange =
                typeof obj.dueDateRange === 'undefined' ? this.dueDateRange : obj.dueDateRange;
            this.buyerInvoiceStatus =
                typeof obj.buyerInvoiceStatus === 'undefined'
                    ? this.buyerInvoiceStatus
                    : obj.buyerInvoiceStatus;
        }
    }
}

export interface DateRange {
    startDate: string;
    endDate: string;
}
